<template>
  <v-row wrap class="pa-5">
    <v-col cols="12">
      <m-breadcrum :items="bread"></m-breadcrum>
    </v-col>
    <v-col cols="12">
      <m-card title="Detail Organisasi" class="pa-5">
        <v-row wrap>
          <v-col cols="12" sm="6" md="6" lg="5" xl="5" class="mt-5">
            <v-card text color="#009688" flat>
              <v-img class="white--text" height="300px" src="img/parallax.png">
                <v-container fill-height container--fluid>
                  <v-row fill-height>
                    <v-col class="text-center" cols="12" align-end flexbox>
                      <v-avatar :size="150" color="grey lighten-4">
                        <!-- <v-img
                          sizes="50"
                          :src="organisasi.file_foto || 'img/organisasi-default.png'"
                          alt="avatar"
                        />-->
                        <img
                          :src="
                            organisasi.file_foto || 'img/organisasi-default.png'
                          "
                          alt="avatar"
                        />
                      </v-avatar>
                    </v-col>
                  </v-row>
                </v-container>
              </v-img>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="7" xl="6">
            <v-row>
              <v-col cols="12" md="6" sm="12">
                <v-list>
                  <v-subheader class="title primary--text"
                    >Identitas organisasi</v-subheader
                  >
                  <m-list-tile-info
                    label="Kode Organisasi"
                    :value="organisasi.kode_organisasi"
                  />
                  <m-list-tile-info
                    label="Nama Organisasi"
                    :value="organisasi.nama"
                  />
                  <m-list-tile-info label="Alamat" :value="organisasi.alamat" />
                </v-list>
              </v-col>
              <v-col cols="12" md="6" sm="12">
                <v-list>
                  <v-subheader class="title primary--text">Kontak</v-subheader>
                  <m-list-tile-info
                    label="No Telepon"
                    :value="organisasi.nama"
                  />
                  <m-list-tile-info
                    label="Alamat Surel"
                    :value="organisasi.email"
                  />
                  <m-list-tile-info label="Fax" :value="organisasi.fax" />
                </v-list>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <v-list>
                  <v-toolbar flat>
                    <v-toolbar-title class="px-0">
                      <v-subheader class="title primary--text px-0"
                        >Informasi Tambahan</v-subheader
                      >
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                  </v-toolbar>
                  <v-divider></v-divider>
                  <m-list-tile-info
                    label="Tanggal Mulai"
                    :value="organisasi.tgl_berlaku_awal | toSD"
                  />
                  <m-list-tile-info
                    label="Tanggal Berakhir"
                    :value="organisasi.tgl_berlaku_akhir | toSD"
                  />
                  <m-list-tile-info
                    label="Total Kuota"
                    :value="(organisasi && organisasi.kuota) || 0"
                  />
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </m-card>
    </v-col>
    <v-col cols="12" md="12" sm="12">
      <m-card-list
        title="Anggota"
        label-cari="Cari Anggota"
        search
        refresh
        filterAnggota
        @filter="filter"
        :items="items"
        :headers="headers"
        @search="
          search => {
            textSearch = search;
            load();
          }
        "
        :page="page"
        @change:page="
          pg => {
            cp = pg;
            load();
          }
        "
        @refresh="load()"
        footer
      >
        <template v-slot:items="{ item }">
          <tr v-if="$vuetify.breakpoint.smAndUp">
            <td>
              <v-row wrap class="pt-3">
                <v-col cols="2" align="center" justify="center">
                  <v-avatar :size="40" color="grey lighten-4">
                    <v-img
                      :src="
                        item.file_foto
                          ? item.file_foto
                          : item.gender == 'P'
                          ? 'img/cewek.png'
                          : 'img/cowok.png'
                      "
                      alt="avatar"
                    />
                  </v-avatar>
                </v-col>
                <v-col cols="10" class="mt-1 pt-1">
                  <p class="subtitle font-weight-bold my-0 py-0">
                    <router-link
                      class="ok"
                      :to="{
                        name: 'user.detail',
                        params: {
                          organisasi_id: organisasi_id,
                          user_id: item.user_id
                        }
                      }"
                      >{{ item.nama | toTitleCase }}</router-link
                    >
                  </p>
                  <p class="grey--text caption">
                    {{ pVal(item, "email") }} <br />
                    {{
                      (item && item.no_pegawai) ||
                        "Belum tersedia nomor pegawai"
                    }}
                  </p>
                </v-col>
              </v-row>
            </td>
            <!-- <td>{{ pVal(item, "tgl_mulai") | toD }}</td> -->
            <td>{{ pVal(item, "role") }}</td>
            <td align="left">
              <v-chip
                small
                outlined
                :color="item.is_face_verified ? 'green' : 'red'"
              >
                <!-- <v-icon
                  small
                  :color="item.is_face_verified ? 'success' : 'error'"
                  >mdi-face-recognition</v-icon
                > -->
                &nbsp;
                {{
                  item.is_face_verified ? "Terverifikasi" : "Belum Verifikasi"
                }}
              </v-chip>
            </td>
            <td>
              <v-chip
                small
                outlined
                :color="item.is_aktif == 1 ? 'info' : 'red'"
                >{{ item.is_aktif == 1 ? "Aktif" : "Tidak Aktif" }}</v-chip
              >
            </td>
            <td>
              <v-chip
                small
                outlined
                :color="item.k_status == 1 ? 'info' : 'red'"
                >{{
                  item.k_status == 1 ? "Sudah Aktivasi" : "Belum Aktivasi"
                }}</v-chip
              >
            </td>
            <td>
              <m-menu
                left
                style="float:right"
                :items="more_menu"
                :object="item"
              />
            </td>
          </tr>
        </template>
      </m-card-list>
    </v-col>
    <form-reset ref="reset" api="user/updatePasswordAdmin" @reload="load"></form-reset>
    <form-email ref="email" @reload="load"></form-email>
  </v-row>
</template>
<script>
import FormReset from "@/modules/pemantau/components/ResetPemantau.vue";
import FormEmail from "@/modules/user/components/ChangeEmail.vue";
export default {
  components: { FormReset, FormEmail },
  data() {
    return {
      organisasi: {},
      items: [],
      page: null,
      cp: 1,
      textSearch: null,
      is_face_verified: null,
      is_aktif: null,
      headers: [
        { text: "Anggota", align: "left", value: "nama" },
        // { text: "Mulai Bekerja", align: "left", value: "tanggal_masuk" },
        { text: "Peran", align: "left", value: "role" },
        // { text: "Gender", align: "left", value: "gender" },
        {
          text: "Verifikasi Wajah",
          align: "left",
          value: "is_face_verified"
        },
        { text: "Status Pengguna", align: "left", value: "is_aktif" },
        { text: "Status Aktivasi", align: "left", value: "k_status" },
        { text: "", align: "center", sortable: false }
      ],
      more_menu: [
        {
          title: "Ubah Peran",
          click: (i, o) => this.setRole(o),
        },
        {
          title: "Ubah Surel",
          click: (i, o) => this.setEmail(o),
        },
        {
          title: "Reset Password",
          click: (i, o) => this.setPass(o),
        },
        {
          title: "Aktivasi",
          click: (i, o) => this.onDisable(o),
          check: (i, o) => Number(o.k_status) != 1
        },
      ]
    };
  },
  computed: {
    kodeOrgs() {
      return this.$route.params.kode_organisasi;
    },

    kodeTenant() {
      return this.$route.params.no_reg;
    },

    bread() {
      return [
        {
          icon: "mdi-bank",
          title: "Tenant",
          to: {
            name: "tenant"
          }
        },
        {
          icon: "mdi-city",
          to: {
            name: "tenant.detail",
            params: {
              no_reg: this.kodeTenant
            }
          },
          title:
            (this.organisasi &&
              this.organisasi.tenants &&
              this.organisasi.tenants.nama) ||
            ""
        },
        {
          icon: "mdi-information",
          title: (this.organisasi && this.organisasi.nama) || ""
        }
      ];
    }
  },

  created() {
    if (this.kodeOrgs) {
      this.getProfil();
    }
  },

  methods: {
    getProfil() {
      this.$store
        .dispatch("organisasi/detail", this.kodeOrgs)
        .then(({ data }) => {
          this.organisasi = data || {};
          this.load();
        });
    },

    filter(data) {
      this.cp = 1;
      this.is_aktif = data.statusUser;
      this.k_status = data.statusAktif;
      this.is_face_verified = data.statusVerifikasi;
      this.role = data.peran;
      this.load();
    },

    load() {
      this.$store
        .dispatch("user/getOrgs", {
          organisasi_id: this.kodeOrgs,
          params: {
            page: this.cp,
            keyword: this.textSearch,
            is_face_verified: this.is_face_verified,
            is_aktif: this.is_aktif,
            k_status: this.k_status,
            role: this.role,
            order_by_nama: true
          }
        })
        .then(res => {
          this.page = res.data;
          this.items = res.data.data;
        })
        .catch(e => e);
    },

    setRole(item) {
      this.$confirmDanger(
        `Apakah anda yakin akan mengatur peran user sesuai data yang Anda pilih?<br>
        <div class='mt-2 title font-weight-bold text-center red--text text--darken-2'>
          ${item.nama}<br><br>
        </div>
        `,
        {
          role: ["Operator", "User"]
          // organisasi: obj.organisasi
        },
        "Ubah Peran"
      )
        .then(res => {
          this.$store
            .dispatch("user/gantiRole", {
              user_id: item.user_id,
              role: res.role,
              organisasi_id: this.kodeOrgs
            })
            .then(res => {
              if (res.code == 200) {
                this.load();
                this.$info("Ubah peran user berhasil");
                return res;
              } else {
                this.$error("Ubah peran user gagal");
              }
            })
            .catch(e => e);
        })
        .catch(e => e);
    },

    setPass(item) {
      this.$refs.reset.open({ id: item.user_id })
    },

    setEmail(item) {
      this.$refs.email.open({ id: item.user_id })
    },

    onDisable(item) {
      const confirmHmtl = {
        konfirmasi: `
        <div class="v-alert v-sheet theme--light v-alert--dense v-alert--text red--text">
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-information theme--light red--text"></i>
                <div class="v-alert__content">
                    Pastikan Anda benar benar mengerti apa yang Anda lakukan
                </div>
            </div>
        </div>
        <div>
            Apakah Anda akan Mengubah status Pengguna berikut menjadi <b>Sudah Aktivasi ?</b>
        </div>
        `,
        deskripsi: `
          <div class="v-alert v-sheet theme--light v-alert--dense v-alert--text red--text">
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-information theme--light red--text"></i>
                <div class="v-alert__content">
                    Anda akan melakukan perubahan status Pengguna dari Belum Aktivasi menjadi Sudah Aktivasi
                </div>
            </div>
        </div>
        <div class="my-5">
            Tulis alasan Anda Mengubah status <b>${item.nama}</b> menjadi <b>Sudah Aktivasi :
        </div>
        `
      };

      this.$confirmDanger(confirmHmtl.konfirmasi, {}, 'Konfirmasi').then(() => {
        this.$store.dispatch("user/ubahAnggota", {
          id: item && item.user_id,
          params: {
            k_status: 1,
            kode_organisasi : this.kodeOrgs
          }
        }).then(() => {
          this.$success("Anggota berhasil di Aktivasi");
          this.load();
        })
      })
    },
  }
};
</script>
